import React from "react";
import { SyncOutlined } from "@ant-design/icons";
import styled from "styled-components";

const StyledSkeletonWrapper = styled.div`
  height: 100vh;
  display: flex;
  background-color: #f0f2f5;
  
  .app-sidebar-skeleton {
    width: 70px;
    background-color: #ffffff;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);
    
    .sidebar-logo {
      width: 50px;
      height: 50px;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  
  .main-sidebar-skeleton {
    width: 250px;
    background-color: #ffffff;
    padding: 20px;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
    
    .ant-skeleton-element {
      margin-bottom: 16px;
    }
  }
  
  .content-area {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  .header-skeleton {
    height: 64px;
    background-color: #ffffff;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    
    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;
      
      .header-logo {
        height: 40px;
        img {
          height: 100%;
          object-fit: contain;
        }
      }
    }
    
    .header-right {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  }
  
  .main-content-skeleton {
    flex: 1;
    background-color: #f0f2f5;
    margin: 24px;
    padding: 24px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    
    .spinner-overlay {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      
      .sync-icon {
        font-size: 100px;
        color: #999999;
        animation: rotate 1s linear infinite;
      }
      
      @keyframes rotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    }
  }
`;

const AppLoader = () => (
  <StyledSkeletonWrapper>
    <div className="main-content-skeleton">
      <div className="spinner-overlay">
        <SyncOutlined className="sync-icon" />
      </div>
    </div>
  </StyledSkeletonWrapper>
);

export default AppLoader;
